<template>
  <v-dialog
    persistent
    v-model="dialog"
    max-width="428px"
    content-class="manual-tip-dialog"
    :transition="isMobile ? 'dialog-bottom-transition' : 'dialog-transition'"
  >
    <v-card data-test-id="MANUAL-TIP-DIALOG">
      <v-toolbar card color="white" v-if="isMobile">
        <v-btn icon @click="handleClose">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title class="flex grow ml-0 pr-4 text-xs-center">
          {{ $t('record.tip_for_driver.enter_tip') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pb-0">
        <h3 class="title font-weight-bold mb-2" v-if="!isMobile">
          {{ $t('record.tip_for_driver.enter_tip') }}
        </h3>
        <v-flex xs12 mb-3>
          <ATextField
            data-test-id="manualTipAmount"
            solo
            :placeholder="$t('record.tip_for_driver.enter_tip_amount')"
            :hint="$t('record.tip_for_driver.enter_tip_hint')"
            persistentHint
            type="number"
            :value="tip"
            :rules="[inputRules.tip]"
            @onChange="(value) => handleChange('tip', value)"
            @onBlur="onBlurTextField('tip')"
            @onError="handleTipError"
          />
        </v-flex>
      </v-card-text>

      <v-card-actions class="px-3 pb-3">
        <v-btn
          depressed
          large
          @click="handleClose"
          data-test-id="CANCEL-BTN"
          class="text-none"
          v-if="!isMobile"
        >
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          large
          depressed
          :disabled="!tip || isInvalidData"
          @click="handleConfirm"
          color="accent"
          data-test-id="SAVE-MANUAL-TIP-BTN"
          class="text-none"
        >
          {{ $t(isMobile ? 'confirm' : 'save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ATextField from '@/components/ahamove/ATextField'

export default {
  name: 'ManualTipModal',
  components: {
    ATextField
  },
  props: {
    onSave: {
      type: Function
    },
    initialValue: {
      type: String
    }
  },
  data() {
    return {
      dialog: false,
      tip: this.initialValue,
      inputRules: {
        tip: (value) => {
          if (!value) return true

          const cleanedValue =
            typeof value === 'string' ? value.replace(/,/g, '').trim() : value.toString()
          const pattern = /^\d+$/
          const isNumber = pattern.test(cleanedValue)
          if (!isNumber) {
            return true
          }
          const tipNumber = parseFloat(cleanedValue)
          if (tipNumber < 1000 || tipNumber > 100000)
            return this.$t('record.tip_for_driver.enter_tip_error')

          return true
        }
      },
      errors: []
    }
  },
  computed: {
    isInvalidData() {
      return this.errors.length > 0
    }
  },
  methods: {
    handleClose() {
      this.dialog = false
    },
    handleConfirm() {
      const isValidData = this.checkValidateData()
      if (!isValidData) return

      this.$emit('onSave', this.tip)
      this.handleClose()
    },
    handleChange(field, value) {
      this[field] = value
    },
    onBlurTextField(value) {
      if (this[value] === null || this[value] === undefined) {
        this[value] = ''
      }
    },
    checkValidateData() {
      this.onBlurTextField('tip', false)
      if (!this.tip) return false
      return true
    },
    handleTipError(value) {
      let data = true
      if (value) {
        data = 'error-message'
      }

      this.handleError('tip', data)
    },
    handleError(field, data) {
      /**
       * [data]
       * @type {Boolean} true - no error
       * @type {String} String of error message
       */
      if (field) {
        if (data === true) {
          const index = this.errors.findIndex((e) => e.key === field)
          this.errors.splice(index, 1)
        } else {
          this.errors.push({
            key: field,
            value: data
          })
        }
      }
    }
  },
  watch: {
    dialog(newVal) {
      if (newVal) {
        this.tip = this.initialValue
      }
    }
  }
}
</script>

<style lang="scss">
.manual-tip-dialog {
  .v-toolbar {
    border-bottom: 1px solid #f2f2f2 !important;
  }

  .v-input--selection-controls {
    margin-top: 12px;

    label {
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #343a3f;
    }
  }

  .a-text-field {
    .v-input__slot {
      border: 1px solid #c1c7cd !important;
      border-radius: 3px;
    }

    &.error--text {
      .v-input__slot {
        border-color: #d44632 !important;
      }
    }
  }

  .v-card__actions {
    .v-btn {
      width: calc(50% - 8px) !important;

      &:first-child {
        margin-right: 8px;
      }

      &:last-child {
        margin-left: 8px;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .manual-tip-dialog {
    margin: 0;
    margin-top: auto;
    max-height: 80% !important;
    border-radius: 8px 8px 0 0;
    display: flex;
    overflow: hidden;

    .v-card {
      display: flex;
      flex-direction: column;
      width: 100%;

      .v-card__actions {
        .v-btn {
          margin: 0 !important;
          width: 100% !important;
        }
      }
    }
  }
}
</style>
